// extracted by mini-css-extract-plugin
export default {"organisations":"t-xPw"};